/* tslint:disable */
/* eslint-disable */
/**
 * SlashID API v1.1
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import type { APIMeta } from './APIMeta';
import {
    APIMetaFromJSON,
    APIMetaFromJSONTyped,
    APIMetaToJSON,
} from './APIMeta';
import type { APIResponseError } from './APIResponseError';
import {
    APIResponseErrorFromJSON,
    APIResponseErrorFromJSONTyped,
    APIResponseErrorToJSON,
} from './APIResponseError';
import type { PostAttestationV3Resp } from './PostAttestationV3Resp';
import {
    PostAttestationV3RespFromJSON,
    PostAttestationV3RespFromJSONTyped,
    PostAttestationV3RespToJSON,
} from './PostAttestationV3Resp';

/**
 * 
 * @export
 * @interface PostAttestationV3200Response
 */
export interface PostAttestationV3200Response {
    /**
     * 
     * @type {APIMeta}
     * @memberof PostAttestationV3200Response
     */
    meta?: APIMeta;
    /**
     * 
     * @type {Array<APIResponseError>}
     * @memberof PostAttestationV3200Response
     */
    errors?: Array<APIResponseError>;
    /**
     * 
     * @type {PostAttestationV3Resp}
     * @memberof PostAttestationV3200Response
     */
    result?: PostAttestationV3Resp;
}

/**
 * Check if a given object implements the PostAttestationV3200Response interface.
 */
export function instanceOfPostAttestationV3200Response(value: object): boolean {
    let isInstance = true;

    return isInstance;
}

export function PostAttestationV3200ResponseFromJSON(json: any): PostAttestationV3200Response {
    return PostAttestationV3200ResponseFromJSONTyped(json, false);
}

export function PostAttestationV3200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): PostAttestationV3200Response {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'meta': !exists(json, 'meta') ? undefined : APIMetaFromJSON(json['meta']),
        'errors': !exists(json, 'errors') ? undefined : ((json['errors'] as Array<any>).map(APIResponseErrorFromJSON)),
        'result': !exists(json, 'result') ? undefined : PostAttestationV3RespFromJSON(json['result']),
    };
}

export function PostAttestationV3200ResponseToJSON(value?: PostAttestationV3200Response | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'meta': APIMetaToJSON(value.meta),
        'errors': value.errors === undefined ? undefined : ((value.errors as Array<any>).map(APIResponseErrorToJSON)),
        'result': PostAttestationV3RespToJSON(value.result),
    };
}

